/** @format */

import React, { useContext, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { useTranslation } from "react-i18next";
import Tooltip from "../../Common/Tooltip";
import { tenantPaymentMethodServices } from "../../../Services/tenantPaymentMethod.service";
import ActionModal from "../../Common/ActionModal";
import ListAdminButtons from "../../Common/ListAdminButtons";
import ResultModal from "../../Common/ResultModal";
import SpinnerLoading from "../../Common/SpinnerLoading";
import AssignPaymentMethod from "./AssignPaymentMethod";
import AddPaymentMethod from "./Create/AddPaymentMethod";
import UpdatePaymentMethod from "./Update/UpdatePaymentMethod";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";

const PaymentMethodTab = ({ tenantId }) => {
  const { t: translator } = useTranslation();
  const { SearchBar } = Search;
  const { locTab } = useContext(GlobalContext);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [update, setUpdate] = useState(new Date());

  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);

  const [resultModal, setResultModal] = useState({
    show: false,
    title: "",
    text: "",
    btnClass: "",
  });

  const [actionModal, setActionModal] = useState({
    show: false,
    title: "",
    text: "",
    confirmBtn: "",
  });

  useEffect(() => {
    if (locTab === "paymentMethod") {
      setIsLoading(true);
      tenantPaymentMethodServices
        .getAllPaymentMethods(tenantId)
        .then(res => {
          setData(res.data.data.filter(x => !x.isDeleted));
          setIsLoading(false);
        })
        .catch(err => console.log(err));
    }
  }, [update, locTab]);

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems(prevValue => [...prevValue, row]);
    } else {
      setSelectedItems(prevValue =>
        prevValue.filter(
          p => p.tenantPaymentMethodId !== row.tenantPaymentMethodId,
        ),
      );
    }
  };

  function actionFormatter(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={
              formatExtraData.length > 0 &&
              formatExtraData.find(
                x => x.tenantPaymentMethodId === row.tenantPaymentMethodId,
              )
            }
            onChange={e => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      setSelectedItems(data);
    } else {
      setSelectedItems([]);
    }
  };

  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={selectedItems.length === data.length && data.length > 0}
            onChange={e => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const columns = [
    {
      dataField: "tenantPaymentMethodId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
      formatter: actionFormatter,
      formatExtraData: selectedItems,

      // hidden: [cashier, accountant].includes(Number(roleId)) ? true : false,
    },
    {
      dataField: "paymentMethodName",
      text: translator("TenantDetails-PaymentMethod-Name"),
    },
    {
      dataField: "tag",
      text: translator("TenantDetails-PaymentMethod-Tag"),
    },
    {
      dataField: "fiscalTag",
      text: translator("TenantDetails-PaymentMethod-FiscalTag"),
    },
  ];

  const confirmDelete = () => {
    let deletePromises = [];

    selectedItems.forEach(x => {
      deletePromises.push(
        tenantPaymentMethodServices.deletePaymentMethod(
          x.tenantPaymentMethodId,
        ),
      );
    });

    Promise.all(deletePromises)
      .then(data => {
        setActionModal({ ...actionModal, show: false });
        setResultModal({
          ...resultModal,
          title: translator(
            "TenantPaymentMethod-ResultModal-DeleteSuccess-Title",
          ),
          text: translator(
            "TenantPaymentMethod-ResultModal-DeleteSuccess-Text",
          ),
          show: true,
          btnClass: "btn btn-primary",
        });
        setUpdate(new Date());
      })
      .catch(err =>
        setResultModal({
          ...resultModal,
          title: translator(
            "TenantPaymentMethod-ResultModal-DeleteSuccess-Title",
          ),
          text: translator(
            "TenantPaymentMethod-ResultModal-DeleteUnSuccess-Text",
          ),
          show: true,
          btnClass: "btn btn-primary",
        }),
      );
    setSelectedItems([]);
  };
  return (
    <>
      <div className="px-3 ">
        <ToolkitProvider
          keyField="tenantPaymentMethodId"
          data={data}
          columns={columns}
          search>
          {props =>
            isLoading ? (
              <div className="dashboard-card-spinner">
                <SpinnerLoading />
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-end">
                  <div>
                    <div>
                      <label className="mt-3">
                        {translator("PayOption-View-Name")}
                      </label>{" "}
                      <Tooltip text={translator("PayOptionTooltip-Msg")} />
                    </div>
                    <SearchBar {...props.searchProps} />
                  </div>
                  <ListAdminButtons
                    selectedItemsLength={selectedItems.length}
                    handleToAdd={() => {
                      setShowAddModal(true);
                    }}
                    handleToAssign={() => {
                      setShowAssignModal(true);
                    }}
                    handleToUpdate={() => {
                      setShowUpdateModal(true);
                    }}
                    handleDelete={() => {
                      setActionModal({
                        show: true,
                        title: "CardTypes-Delete-Title",
                        text: "CardTypes-Delete-Text",
                        confirmBtn: "CardTypes-Delete-Btn",
                      });
                    }}
                  />
                </div>
                <hr />
                <BootstrapTable
                  {...props.baseProps}
                  rowClasses="boostrap-table-row"
                  // rowEvents={rowEvents}
                  noDataIndication={translator("No-Data")}
                  pagination={paginationFactory({})}
                  // onTableChange={onTableChange}
                />
              </>
            )
          }
        </ToolkitProvider>
      </div>

      {showAddModal && (
        <AddPaymentMethod
          show={showAddModal}
          setShow={setShowAddModal}
          tenantId={tenantId}
          setResultModal={setResultModal}
          onHide={() => {
            setUpdate(new Date());
            setShowAddModal(false);
            setSelectedItems([]);
          }}
        />
      )}

      {showUpdateModal && (
        <UpdatePaymentMethod
          show={showUpdateModal}
          setShow={setShowUpdateModal}
          tenantId={tenantId}
          data={selectedItems[0]}
          setResultModal={setResultModal}
          onHide={() => {
            setUpdate(new Date());
            setShowUpdateModal(false);
            setSelectedItems([]);
          }}
        />
      )}

      <AssignPaymentMethod
        show={showAssignModal}
        tenantId={tenantId}
        setShow={setShowAssignModal}
        setResultModal={setResultModal}
        onHide={() => {
          setUpdate(new Date());
          setShowAssignModal(false);
          setSelectedItems([]);
        }}
      />

      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={() => {
          setResultModal({ ...resultModal, show: false });
          setSelectedItems([]);
        }}
      />
      {selectedItems.length > 0 && (
        <ActionModal
          show={actionModal.show}
          handleHide={() => {
            setActionModal({ ...actionModal, show: false });
          }}
          title={actionModal.title}
          text={actionModal.text}
          confirmBtn={actionModal.confirmBtn}
          confirmAction={confirmDelete}
        />
      )}
    </>
  );
};

export default PaymentMethodTab;
